import { RouteObject } from "react-router";
import { LabsRoute } from "./labs/labs-route";
import { LabListRoute } from "./labs/lab-list-route";
import { LabRoute } from "./labs/[labId]/lab-route";

export const samplesBaseDataRoutes: RouteObject[] = [
  {
    path: "labs",
    element: <LabsRoute />,
    children: [
      {
        index: true,
        element: <LabListRoute />,
      },
      {
        path: ":labId",
        element: <LabRoute />,
      },
    ],
  },
];
